const nav = {
    aiScheduler: 'Scheduler AI (App Demo)',
    fileUpload: 'Carica File (AWS S3)',
    documentation: 'Documentazione',
    blog: 'Blog',
    login: 'ACCEDI',
    logout: 'ESCI',
    home: 'HOME',
    trips: 'VIAGGI',
    products: 'Prodotti',
    cart: 'CARRELLO',
    aboutUs: 'CHI SIAMO',
    myAccount: 'IL MIO ACCOUNT',
    signUp: 'REGISTRATI',
    contacts: 'CONTATTI'
};

export default nav;
